/* global axios */
import ApiClient from '../ApiClient';

class LazadaChannel extends ApiClient {
  constructor() {
    super('lazada', { accountScoped: true });
  }

  generateAuthorization(region = 'lazada_my') {
    return axios.post(`${this.url}/authorization`, { region });
  }
}

export default new LazadaChannel();
